import { render, staticRenderFns } from "./PageHeaderNavigator.vue?vue&type=template&id=a974b514&scoped=true&"
import script from "./PageHeaderNavigator.vue?vue&type=script&lang=ts&"
export * from "./PageHeaderNavigator.vue?vue&type=script&lang=ts&"
import style0 from "./PageHeaderNavigator.vue?vue&type=style&index=0&id=a974b514&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a974b514",
  null
  
)

export default component.exports